//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Asides from '@/layout/component/aside.vue';
import Headers from '@/layout/component/header.vue';
import Mains from '@/layout/component/main.vue';
import TagsView from '@/layout/navBars/tagsView/tagsView.vue';
export default {
  name: 'layoutClassic',
  components: {
    Asides: Asides,
    Headers: Headers,
    Mains: Mains,
    TagsView: TagsView
  },
  computed: {
    // 获取布局配置信息
    getThemeConfig: function getThemeConfig() {
      return this.$store.state.themeConfig.themeConfig;
    }
  }
};